import {EventBus} from "../utils/event-bus";

export default {
  close3dSecureModal() {
    console.log('close3dSecureModal');
    return new Promise((resolve, reject) => {
      const modal = document.querySelector('[name^="__privateStripeFrame"]');

      if (modal) {
        modal.parentNode.remove();

        resolve(true);
      } else {
        reject(false);
      }
    })
  },
  handle3dSecureModal() {
    console.log('handle3dSecureModal');
    return new Promise((resolve, reject) => {
      const onModalClose = () => {
        this.close3dSecureModal()
               .then(() => resolve(true))
               .catch(() => reject(false))
               .finally(() => EventBus.$off('wk-on-modal-close', onModalClose));
      };

      EventBus.$on('wk-on-modal-close', onModalClose);
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/stripe.js